<template>
  <div>
    <button
      @click="check()"
      v-permissions="'Add Shipment Type'"
      target="_blank"
      class="new-btn shipment-doc-edit-btn"
    >
      Edit
    </button>
    <v-dialog
      v-model="dialog"
      content-class="shipment-doc-dialog shipment-doc-form-dialog shipment-doc-edit-dialog"
      max-width="54rem"
      persistent
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="shipment-doc-dialog-card shipment-doc-edit-dialog-card">
          <v-card-title class="shipment-doc-dialog-title shipment-doc-edit-dialog-title">
            <span>Edit Shipment Document</span>
            <v-spacer></v-spacer>
            <v-btn
              class="shipment-doc-dialog-close"
              :disabled="processing"
              icon
              @click.prevent="closeDialog()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-progress-linear
            indeterminate
            color="yellow darken-2"
            v-show="processing"
          ></v-progress-linear>
          <div class="shipment-doc-dialog-content shipment-doc-edit-dialog-content">
            <v-card-text class="shipment-doc-form-body">
              <v-container grid-list-md class="shipment-doc-form-grid">
                <v-layout class="shipment-doc-form-row shipment-doc-form-row--single">
                  <v-flex xs12 sm6 class="shipment-doc-form-field">
                    <span class="shipment-doc-field-label">Shipment Type</span>
                    <v-text-field
                      label="Enter shipment type"
                      v-model="documentName"
                      :rules="[rules.noWhiteSpace, rules.required]"
                      single-line
                      class="pt-0 currencyTitle"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="shipment-doc-form-row">
                  <v-flex xs12 sm4 class="shipment-doc-form-field">
                    <span class="shipment-doc-field-label">Job Type</span>
                    <v-autocomplete
                      :items="shipmentTypes"
                      v-model="shipmentType"
                      item-text="text"
                      item-value="value"
                      class="pt-0 currencyTitle"
                      label="Select"
                      required
                      single-line
                      :rules="[rules.required]"
                    />
                  </v-flex>
                  <v-flex xs12 sm4 class="shipment-doc-form-field">
                    <span class="shipment-doc-field-label">Job Booking Type</span>
                    <v-select
                      :items="jobBookingTypes"
                      v-model="jobBookingType"
                      item-text="text"
                      item-value="value"
                      class="pt-0 currencyTitle"
                      label="Select"
                      multiple
                      single-line
                      :rules="[rules.requiredLength]"
                    />
                  </v-flex>
                  <v-flex xs12 sm4 class="shipment-doc-form-field">
                    <span class="shipment-doc-field-label">Geography</span>
                    <v-select
                      :items="jobGeoTypes"
                      v-model="jobGeoType"
                      item-text="text"
                      item-value="value"
                      class="pt-0 currencyTitle"
                      label="Select"
                      multiple
                      single-line
                      @change="jobModeEmpty()"
                      :rules="[rules.requiredLength]"
                    />
                  </v-flex>
                </v-layout>
                <v-layout class="shipment-doc-form-row">
                  <v-flex xs12 sm4 class="shipment-doc-form-field" v-if="jobGeoType == '1'">
                    <span class="shipment-doc-field-label">Job Mode</span>
                    <v-select
                      :items="jobModeInternational"
                      v-model="jobMode"
                      item-text="text"
                      item-value="value"
                      class="pt-0 currencyTitle"
                      :disabled="!this.jobGeoType.length"
                      label="Select"
                      multiple
                      single-line
                      :rules="[rules.requiredLength]"
                    />
                  </v-flex>
                  <v-flex xs12 sm4 class="shipment-doc-form-field" v-else>
                    <span class="shipment-doc-field-label">Job Mode</span>

                    <v-select
                      :items="jobModes"
                      v-model="jobMode"
                      item-text="text"
                      item-value="value"
                      :disabled="!this.jobGeoType.length"
                      class="pt-0 currencyTitle"
                      label="Select"
                      multiple
                      single-line
                      :rules="[rules.requiredLength]"
                    />
                  </v-flex>
                  <v-flex xs12 sm4 class="shipment-doc-form-field">
                    <span class="shipment-doc-field-label">Stakeholders</span>
                    <v-select
                      v-model="stakeholder"
                      label="Select"
                      item-text="text"
                      item-value="value"
                      :items="stakeholders"
                      class="pt-0 currencyTitle"
                      :rules="[rules.requiredLength]"
                      multiple
                      single-line
                    />
                  </v-flex>
                  <v-flex xs12 sm4 class="shipment-doc-form-field">
                    <span class="shipment-doc-field-label">Working Country</span>
                    <v-select
                      v-model="countrySortName"
                      label="Select"
                      class="pt-0 currencyTitle"
                      :items="workingCountries"
                      item-text="value"
                      item-value="value"
                      multiple
                      :rules="[rules.requiredLength]"
                      single-line
                    />
                  </v-flex>
                </v-layout>
              </v-container>
              <!-- <small class="success" v-show="this.res">{{ this.res }}</small> -->
            </v-card-text>
            <v-card-actions class="shipment-doc-dialog-actions">
              <v-spacer></v-spacer>
              <v-btn
                class="shipment-doc-secondary-action"
                flat
                @click="closeDialog()"
                :disabled="processing"
                >Close</v-btn
              >
              <v-btn
                class="shipment-doc-primary-action"
                :disabled="processing"
                flat
                @click="edit()"
                >Save</v-btn
              >
            </v-card-actions>
          </div>
        </v-card>
      </v-form>
      <!-- <ErrorBox :error="x.error" /> -->
      <v-snackbar
        :timeout="3000"
        bottom
        color="red darken-2"
        v-model="x.error"
        class="white--text"
        v-if="x.error"
        >{{ x.error }}</v-snackbar
      >
    </v-dialog>
  </div>
</template>
<script>
import {
  StorageKeys,
  JobTypes,
  JobGeoType1,
  JobBookingType1,
  StakeHolders,
  JobMode1,
  WorkingCountries,
  JobModeInternational,
} from "../../constants/constants";
import { salesSectionApiUrl } from "../../constants/api-urls";
import ErrorBox from "@/components/Common/ErrorBox";
export default {
  created() {
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
    }
    this.shipmentTypes = JobTypes;
    this.jobGeoTypes = JobGeoType1;
    this.jobModes = JobMode1;
    this.stakeholders = StakeHolders;
    this.jobBookingTypes = JobBookingType1;
    this.jobModeInternational = JobModeInternational;
  },
  data() {
    return {
      checkbox1: false,
      shipmentTypes: [],
      jobModeInternational: [],
      documentName: "",
      countrySortName: [],
      multipleCountry: [
        { value: "KSA", currency: "SAR" },
        { value: "UAE", currency: "AED" },
        { value: "PAK", currency: "PKR" },
        { value: "UAE LA", currency: "AED" },
        { value: "OMAN", currency: "OMR" },
      ],
      jobBookingTypes: [],
      stakeholders: [],
      jobModes: [],
      jobGeoTypes: [],
      valid: true,
      shipmentType: "",
      jobMode: [],
      stakeholder: [],
      jobBookingType: [],
      jobGeoType: [],
      lazy: false,
      index: 0,
      res: "",
      dialog: false,
      message: null,
      loading: false,
      processing: false,
      x: {
        error: "",
      },
      rules: {
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "This field is required.",
        required: (value) => !!value || "This field is required.",
        requiredLength: (value) => !!value.length || "This field is required.",
      },
    };
  },
  components: {
    ErrorBox,
  },
  props: ["documentNumber"],
  methods: {
    async check() {
      this.operationName = "Add Shipment Type";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.dialog = true;
        this.getDetails();
      } else {
        return;
      }
    },
    jobModeEmpty() {
      this.jobMode = [];
    },
    closeDialog() {
      this.dialog = false;
      //   (this.documentName = ""),
      //     (this.shipmentType = ""),
      //     (this.shipmentType = ""),
      //     (this.jobMode = ""),
      //     (this.stakeholder = []),
      //     (this.jobBookingType = ""),
      //     (this.jobGeoType = ""),
      //     (this.countrySortName = []),
      //     this.$refs.form.resetValidation();
    },
    getDetails() {
      if (this.processing) {
        return;
      }

      this.processing = true;
      let url = salesSectionApiUrl.getSingleShipmentType;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        documentNumber: this.$props.documentNumber,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.processing = false;
          this.documentName = response.data.data[0].documentName;
          this.shipmentType = response.data.data[0].jobType;
          this.jobMode = response.data.data[0].jobMode;
          this.jobBookingType = response.data.data[0].bookingType;
          this.countrySortName = response.data.data[0].country;
          this.stakeholder = response.data.data[0].stakeHolder;
          this.jobGeoType = response.data.data[0].jobGeoType;
        },
        (error) => {
          this.processing = false;
          //this.x.error = error.response.data.message;
        }
      );
    },
    edit() {
      if (this.processing) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.processing = true;
        let url = salesSectionApiUrl.editShipmentType;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          documentNumber: this.$props.documentNumber,
          documentName: this.documentName,
          jobType: this.shipmentType,
          jobGeoType: this.jobGeoType,
          bookingType: this.jobBookingType,
          stakeHolder: this.stakeholder,
          jobMode: this.jobMode,
          country: this.countrySortName,
        };
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.res = response.data.message;
            this.closeDialog();
            this.$eventBus.$emit("edit-shipment-doc");
            this.processing = false;
          },
          (error) => {
            this.processing = false;
            this.x.error = error.response.data.message;
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.message {
  display: inline-block;
  margin: 0 50px;
}
.btn-wrapper {
  border: 2px solid red;
  color: red;
  background-color: white;
  padding: 8px 20px;
  cursor: pointer !important;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
}
.list {
  display: inline-block;
  padding: 10px;
}
.custom-file-upload {
  border: none;
  display: inline-block;
  background: #ea7a1c;
  font-size: 16px;
  color: #fff;
  padding: 10px 12px;
  cursor: pointer;
}
</style>
